// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"e2f38a94f35409cb6a1a","661":"019dca90d98461546c0c","2838":"cf5554d33440d2e04456"}[chunkId] + ".chunk.js";
};